module.exports = __webpack_public_path__ + "img/shareLink.ca917adc.svg";